import { render, staticRenderFns } from "./RelatedPage.vue?vue&type=template&id=744d8f2d&scoped=true&"
import script from "./RelatedPage.vue?vue&type=script&lang=js&"
export * from "./RelatedPage.vue?vue&type=script&lang=js&"
import style0 from "./RelatedPage.vue?vue&type=style&index=0&id=744d8f2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744d8f2d",
  null
  
)

export default component.exports